import IPermissions from '../interface/user/IPermissions';
import { IUserSecurityDto } from '../interface/user/IUserSecurityDto';
import { IUserSecurityOfficerDto } from '../interface/user/officer/IUserSecurityOfficerDto';

const AuthPermissions = (currentUser: IUserSecurityDto | IUserSecurityOfficerDto): IPermissions => {
  function findRule(ruleToSearch: string): boolean {
    let hasRule = false;
    if (currentUser.profiles) {
      currentUser.profiles.forEach(profile => {
        if (profile.rules.find(rule => rule.name === ruleToSearch)) {
          hasRule = true;
        }
      });
    }

    if (!hasRule && currentUser.rules.find(rule => rule.name === ruleToSearch)) {
      hasRule = true;
    }

    return hasRule;
  }

  function findProfile(profileToSearch: string): boolean {
    let hasProfile = false;

    if (currentUser.profiles.find(profile => profile.name === profileToSearch)) {
      hasProfile = true;
    }
    return hasProfile;
  }

  return {
    isMaster: findProfile('Master'),
    enableFinanceKey: findProfile('Finance'),
    enableFundingKey: findProfile('Fundings Payments'),
    canArchive: findRule('RULE_ADMIN_CAN_ARCHIVE'),
    canSeeCommission: findRule('RULE_OFFICER_VIEW_COMMISSION'),
    canApproveSpecialProjectValid: findRule('RULE_CAN_APPROVE_SPECIAL_PROJECT_VALID'),
    canApproveDocumentApproval: findRule('RULE_CAN_APPROVE_DOCUMENT_APPROVAL'),
    canApproveCompliance: findRule('RULE_CAN_APPROVE_COMPLIANCE'),
    canApproveDiligence: findRule('RULE_CAN_APPROVE_DILIGENCE'),
    canPrecifyWithManualMaturityDateTools: findRule('RULE_TOOLS_CAN_PRECIFY_WITH_MANUAL_MATURITY_DATE'),
    canPrecifyWithManualMaturityDateContingency: findRule('RULE_CONTINGENCY_CAN_PRECIFY_WITH_MANUAL_MATURITY_DATE'),
    canApproveSpecialSituation: findRule('RULE_CAN_APPROVE_SPECIAL_SITUATION'),
    canApproveAttorneyAberto: findRule('RULE_CAN_APPROVE_ATTORNEY_ABERTO'),
    canApprovePreDisbursement: findRule('RULE_CAN_APPROVE_PRE_DISBURSEMENT'),
    canApproveCredit: findRule('RULE_ADMIN_CAN_APPROVE_CREDIT'),
    canRepriceTradeContingency: findRule('RULE_CONTINGENCY_REPRICE_TRADE'),
    canCreateP2Contingency: findRule('RULE_CREATE_P2_CONTINGENCY'),
    canReprocessFraud: findRule('RULE_CONTINGENCY_REPROCESS_FRAUD'),
    canReprocessPaymentRequest: findRule('RULE_CONTINGENCY_REPROCESS_PAYMENT_REQUEST'),
    canEditOperationCostTradeContingency: findRule('RULE_CONTINGENCY_EXPENSES_TRADES'),
    canUniproofContingency: findRule('RULE_CONTINGENCY_UNIPROOF'),
    canReprocessBCheck: findRule('RULE_CONTINGENCY_RELOAD_BCHECK'),
    canReprocessPreFraud: findRule('RULE_CONTINGENCY_REPROCESS_PRE_FRAUD'),
    canEditPrecatorio: findRule('RULE_CONTINGENCY_CAN_EDIT_PRECATORIO'),
    canEditCartorio: findRule('RULE_CONTINGENCY_CAN_EDIT_CARTORIO'),
    canEditSpecialProjectContingency: findRule('RULE_CONTINGENCY_CAN_EDIT_SPECIAL_PROJECT'),
    canEditUserContingency: findRule('RULE_CONTINGENCY_CAN_EDIT_ALL_TRADE_USER'),
    canEditUserInSpecialProjectContingency: findRule('RULE_CONTINGENCY_CAN_EDIT_ONLY_SPECIAL_PROJECT_TRADE_USER'),
    canApprovePreCartorio: findRule('RULE_ADMIN_CAN_APPROVE_PRE_CARTORIO'),
    canApprovePreFraud: findRule('RULE_ADMIN_CAN_APPROVE_PRE_FRAUD'),
    canApproveFraud: findRule('RULE_ADMIN_CAN_APPROVE_FRAUD'),
    canMoveTradeAllPhases: findRule('RULE_MAINTENANCE_CAN_MOVE_TRADE_ALL_PHASES'),
    canNotifyOnMoveTradePhase: findRule('RULE_MAINTENANCE_CAN_NOTIFY_ON_MOVE_TRADE_PHASE'),
    canActivatePricingDisbursement: findRule('RULE_CAN_ACTIVATE_PRICING_DISBURSEMENT'),
    canViewFixedCommission: findRule('CAN_VIEW_FIXED_COMMISSION'),
    canSwitchDisbursementMethod: findRule('RULE_CAN_SWITCH_DISBURSEMENT_METHOD'),
    canApprovePreSpecialSituations: findRule('RULE_WORKFLOW_PRE_SPECIAL_SITUATION'),
    canBypassSpecialSituationValidations: findRule('RULE_ADMIN_CAN_BYPASS_SPECIAL_SITUATION_VALIDATIONS'),
    CanUserViewParametersPricingDrl: findRule('RULE_ADMIN_USER_VIEW_PARAMETERS_PRICING_DRL'),
    canConfigurationTicketRangeControl: findRule('RULE_COMERCIAL_CONFIG_TICKET_CONTROL'),
    canViewDebtRolloverNotification: findRule('RULE_CAN_VIEW_DEBT_ROLLOVER_NOTIFICATION'),

    //#region VIEW BUTTONS
    canViewLogs: findRule('RULE_USER_CAN_VIEW_LOGS'),
    canViewUploadDocumentButton: findRule('RULE_VIEW_UPLOAD_BUTTON'),
    canViewPostPurchaseFundingButton: findRule('RULE_VIEW_POST_PURCHASE_FUNDING_BUTTON'),
    canViewPostPurchaseFinanceButton: findRule('RULE_VIEW_POST_PURCHASE_FINANCE_BUTTON'),
    canViewPostPurchaseInformationButton: findRule('RULE_VIEW_POST_PURCHASE_INFORMATION_BUTTON'),
    canViewPostPurchaseExposureButton: findRule('RULE_VIEW_POST_PURCHASE_EXPOSURE_BUTTON'),
    canViewPostPurchaseUpdateButton: findRule('RULE_VIEW_POST_PURCHASE_UPDATE_BUTTON'),
    canViewToggleAccrualButton: findRule('RULE_VIEW_TOGGLE_ACCRUAL_BUTTON'),
    canViewUDiligenceQuestionnaireButton: findRule('RULE_VIEW_DILIGENCE_QUESTIONNAIRE_BUTTON'),
    canViewUAnalysisButton: findRule('RULE_VIEW_ANALYSIS_BUTTON'),
    canViewTicketRequestButton: findRule('RULE_VIEW_TICKET_REQUEST_BUTTON'),
    canViewTEDButton: findRule('RULE_VIEW_TED_BUTTON'),
    canViewDownloadPublicDeedButton: findRule('RULE_VIEW_PUBLIC_DEED_BUTTON'),
    canViewUploadButton: findRule('RULE_VIEW_UPLOAD_BUTTON'),
    canViewProvisionButton: findRule('RULE_VIEW_PROVISION_BUTTON'),
    canStopAccrual: findRule('RULE_CAN_STOP_ACCRUAL'),
    canStartAccrual: findRule('RULE_CAN_START_ACCRUAL'),
    canViewUpdateTradePricing: findRule('RULE_ADMIN_CAN_VIEW_BUTTON_UPDATE_TRADE_PRICING'),
    canViewPriceComissionButton: findRule('RULE_ADMIN_CAN_VIEW_BUTTON_PRICE_COMISSION'),
    //#endregion

    //#region VIEW Trade Deatils
    canViewTradeGeneralInfo: findRule('RULE_VIEW_TRADE_GENERAL_INFO'),
    canViewTradeDocuments: findRule('RULE_VIEW_TRADE_DOCUMENTS'),
    canViewTradeClientInfo: findRule('RULE_VIEW_TRADE_CLIENT_INFO'),
    canViewTradeClientSpouseInfo: findRule('RULE_VIEW_TRADE_CLIENT_SPOUSE_INFO'),
    canViewTradePricing: findRule('RULE_VIEW_TRADE_PRICING'),
    canViewTradeLawyerInfo: findRule('RULE_VIEW_TRADE_LAWYER_INFO'),
    //#endregion

    //#region VIEW Deal Deatils
    canViewDealGeneralInfo: findRule('RULE_VIEW_DEAL_GENERAL_INFO'),
    canViewDealDocuments: findRule('RULE_VIEW_DEAL_DOCUMENTS'),
    canViewDealPricing: findRule('RULE_VIEW_DEAL_PRICING_INFO'),
    canApproveDataSend: findRule('RULE_VIEW_DEAL_CAN_APPROVE_DATA_SEND'),
    canApproveDealDiligence: findRule('RULE_VIEW_DEAL_CAN_APPROVE_DILIGENCE'),
    canApproveAnalysis: findRule('RULE_VIEW_DEAL_CAN_APPROVE_ANALYSIS'),
    canViewPendencies: findRule('RULE_VIEW_DEAL_PENDENCIES')
    //#endregion
  }
};

export default AuthPermissions;
